import React, { useEffect } from 'react';
import styled, { keyframes} from 'styled-components';
import ConsentBox from './components/consent-box/ConsentBox';
import { useAppState } from './data';
import { CookieService } from './lib/cookie-service';

const FadeIn = keyframes`
  0% {
    opacity: 0
  }

  100% {
    opacity: 1
  }
`;

const Overlay = styled.div<{open: boolean}>`
  background: rgba(0, 0, 0, .5);
  z-index: ${props => props.open ? '2147483643' : '2147483640'};
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  animation-name: ${FadeIn};
  animation-duration: 400ms;
  animation-timing-function: ease-in-out;
`;

const cookieService = new CookieService();

function App() {
  const {
    showApp,
    setShowApp,
    isFetching,
    openDialog,
    setOpenDialog,
    setCookiesConfig,
    cookiesConfig,
    appConfig,
    setShowBottomPanel,
  } = useAppState();

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      if (appConfig && cookiesConfig) {
        Object.keys(cookiesConfig).forEach((index: any) => {
          if (!cookiesConfig[index] && appConfig.cookiesConfigs && appConfig.cookiesConfigs[index]) {
            appConfig.cookiesConfigs[index].cookies.forEach(cookie => {
              cookieService.delete(cookie.name);
            });
          }
        })
      }
    }, 100);

    const storageCallback = (event: StorageEvent) => {
      if (event.key === 'sydle_one_lgpd_config') {
        try {
          setCookiesConfig(JSON.parse(event.newValue!));
        } catch(_) {
          setCookiesConfig({});
        }
      }
    };

    window.addEventListener('storage', storageCallback);
    return () => {
      window.removeEventListener('storage', storageCallback);
      window.clearInterval(intervalId);
    }
  }, [appConfig, cookiesConfig, setCookiesConfig]);

  useEffect(() => {
    window.LGPD_API = {
      ...window.LGPD_API,
      showOverlay: () => {
        setShowApp(true);
        setShowBottomPanel(true);
        setOpenDialog(false);
      },
      openConfigDialog: () => {
        setShowApp(true);
        setShowBottomPanel(false);
        setOpenDialog(true);
      }
    };
  }, [setShowApp, setOpenDialog, setShowBottomPanel]);
  
  return (showApp && !isFetching)? (
    <>
      <Overlay as="ldiv" open={openDialog}/>
      <ConsentBox />
    </>
  ) : null;
}

export default App;
